const BASE = process.env.NEXT_PUBLIC_API_BASE_URL;
// v3
export const SEND_CODE = `${BASE}api/v3/auth/sms-verification`;
export const LOGIN = `${BASE}api/v3/auth/login`;
export const PERSONAL_INFO = `${BASE}api/v3/auth/me`;
export const UPDATE_PERSONAL_INFO = 'api/v3/user/profile/update';
export const RESEND_PHONE_CODE = 'api/v3/auth/resend-sms-verification';
export const START_ARCHIVING = 'api/v3/archiving/start';
export const LOGIN_USER_ID = 'api/v3/login-using-id';
export const BOOKINGS_LIST = 'api/v3/user/intercom_bookings_list';
export const LIBRARY_BOOKS = 'api/v3/saudi-curriculum-subjects';
export const CLOSE_GRADES_ONBOARDING = (bookigId) =>
    `api/v3/tutor/close-grades-onboarding?booking_id=${bookigId}`;
export const CLOSE_REGULAR_CLASS_ONBOARDING = (bookingId) =>
    `api/v3/tutor/close-regular-class-onboarding?booking_id=${bookingId}`;
export const CLOSE_DEMO_RECORDING = `${BASE}api/v3/tutor/close-demo-recording`;
// Get tutor profile
export const TUTOR_PROFILE = 'api/v3/user/profile/tutor';
export const BOOK_TUTOR = 'api/v3/booking/insert';
export const BOOK_TUTOR_AUTO_ACCEPT = 'api/v3/booking/insert-auto-accept';
export const CHECK_SUBJECT_BOOKING_STATUS = 'api/v3/booking/check-subject-booking';
export const CALCULATE_TUTOR_MATCH_PERCENTAGE = 'api/v3/booking/calculate-match-percentage';
export const INTERCOM_BOOK_TUTOR = 'api/v3/booking/insertWithUserID';
export const STAGES = 'api/v3/general/levels';

export const SPONSOR_DEACTIVATION_MESSAGE =
    'api/v3/sponsor/get-deactivation-message';
export const SUBJECTS = 'api/v3/general/subjects';

// COOPERATION
export const COOPERATION_URL = 'api/v3/cooperators';
export const COOPERATION_REQUEST = (cooperationName) =>
    `api/v3/cooperators/${cooperationName}/form`;
export const MARKETING_URL = 'api/v3/marketers';
// Tamara payment
export const TAMARA_PAYMENT_TYPES = (orderValue) =>
    `api/v3/tamara/payment-types?order_value=${orderValue}`;
export const TAMARA_CHECKOUT = 'api/v3/tamara/checkout';
export const PAYMENTS_CHECKOUT = 'api/v3/payments/checkout';
export const PAYMENTS_VERIFY = 'api/v3/payments/verify';

// Tabby Payment
export const TABBY_PAYMENT_TYPES = (orderValue) =>
    `api/v3/tabby/payment-types?order_value=${orderValue}`;


// Redeem Card
export const REDEEM_VOUCHER = 'api/v3/redeem-code';
// booking
export const BOOKING_ORDERS = 'api/v3/booking/BookingList';
export const STUDENT_SESSIONS_CALENDAR = 'api/v3/student/sessions/calendar';
export const STUDENT_SESSIONS_CALENDAR_FOR = (studentId) =>
  `api/v3/students/${studentId}/sessions/calendar`;
export const STUDENT_SESSION_SUMMARY_FOR = (studentId) =>
  `api/v3/students/${studentId}/session-summary`;
export const ORDER_DETAILS = 'api/v3/booking/details';
export const CANCEL_BOOKING_REASONS = 'api/v3/general/status-reasons';
export const CHANGE_STATUS = 'api/v3/booking/change-status';
export const INVITED_BOOKINGS = 'api/v3/booking/group/check_invitations';
export const START_SESSION_BY_TUTOR = 'api/v3/sessions/start';
export const START_TRAINING_SESSION_RECORDING_BY_TUTOR =
    'api/v3/sessions/start-training-recording';
export const UPDATE_SESSION_DURATION = 'api/v3/sessions/add_time';
export const END_ONLINE_SESSION = 'api/v3/sessions/end';
export const JOIN_SESSION_BY_STUDENT = 'api/v3/sessions/join_by_student';
export const DISCOUNT_CODE = 'api/v3/booking/discount';
export const BOOKING_HOURS = 'api/v3/booking/hours';
export const BOOKING_REVIEW = 'api/v3/booking/review';
export const INTERCOM_BOOKING_LIST = 'api/v3/user/intercom_bookings_list';
export const CALL_BRIDGE = 'api/v3/call-bridge'; // ===> api/v3/call-bridge/{booking_id}
export const COMPLETE_TUTOR_REGISTRATION_FORM = 'api/v3/complete-form';
export const BOOKING_ATTACHMENTS_URL = (bookingId) =>
    `api/v3/bookings/${bookingId}/attachments`;
export const SESSION_DETAILS = (bookingId) =>
    `api/v3/bookings/${bookingId}/sessions`;
export const GET_BOOKING_LESSONS = (subjectId, semesterId) =>
    `api/v3/bookings/${subjectId}/lessons?semester_id=${semesterId}`;
export const SUBMIT_FEEDBACK = (bookingId) =>
    `api/v3/bookings/${bookingId}/feedback`;
export const CHECK_STUDENT_JOINED = (sessionClassId) =>
    `api/v3/sessions/${sessionClassId}/can-show-feedback`;

export const SUBMIT_STUDENT_GRADES = (bookingId) =>
    `api/v3/bookings/${bookingId}/grades`;
export const SUBMIT_STUDENT_PROFILES = (userId) =>
    `api/v3/users/${userId}/profiles`;
export const GET_STUDENT_PROFILES = (userId) =>
    `api/v3/users/${userId}/profiles`;
export const GET_TRANSCRIPTS = (studentId) =>
    `api/v3/students/${studentId}/transcripts`;
export const POST_TRANSCRIPTS = (studentId) =>
    `api/v3/students/${studentId}/transcripts`;
// Student
export const STUDENT_SESSION_RATING = 'api/v3/sessions/rating';
export const LEADERBOARD = 'api/v3/leaderboard';
export const COMPLAINT_ONBOARD = (bookingId) =>
    `api/v3/student/close-complaints-onboarding?booking_id=${bookingId}`;
export const CLOSE_POINTS_PAGE = 'api/v3/student/close-points';
export const CONFIRM_SPINNING_WHEEL = 'api/v3/student/confirm-spinning-wheel';
export const CLOSE_SPINNING_WHEEL = 'api/v3/student/close-spinning-wheel';
export const STUDENT_COMPLAINT = (bookingId) =>
    `api/v3/bookings/${bookingId}/student-complaints`;

//v2
export const CITIES_LIST = 'apiv2/search/locations';
export const SIGN_UP = 'apiv2/user/registration';

// Personal Info
export const PERSONAL_INFO_UPDATE = 'api/v3/user/profile/update';

//by student
export const CHANGE_INVITED_BOOKING_STATUS =
    'api/v3/booking/group/change_status';

// Create stream
export const CREATE_STREAM = 'online/stream_created_logs';

export const REQUEST_SUBJECT = 'apiv2/search/request_subject';
// deprecated
export const END_ONLINE_SESSION_OLD_MOBILE = 'apiv2/booking/end_online_session';

export const AUDIO_VIDEO_QUALITY_TEST = 'api/v3/booking/video-audio-quality';
export const TUTOR_SCHEDULE_AVAILABLE_SLOT = 'api/v3/tutor-schedule-slots';
export const CHECK_BOOKING_CREATION_STATUS =
    'https://api.faheemapp.com/api/v3/booking/check-university-booking-creation-status';
export const INVITE_TUTOR_TO_BOOKING = `${BASE}api/v3/booking/invite-tutor-to-booking`;
export const REJECT_BOOKING = `${BASE}api/v3/booking/reject-invitation`;
export const GET_SUBJECT_INFO = '/api/v3/general/subject/';
export const GET_PREPAID_PACKAGES = 'api/v3/prepaid-packages';
export const PREPAID_PACKAGE_VERIFY_COUPON =
    'api/v3/prepaid-packages/verify_coupon';
export const GET_OR_POST_BOOKING_ATTACHMENT = (bookingId) =>
    `/api/v3/bookings/${bookingId}/attachments`;

// tutor reschedule
export const TUTOR_RESCHEDULE = (bookingId) =>
    `/api/v3/bookings/${bookingId}/reschedule`;
export const CLOSE_RESCHEDULE_ONBOARDING = (bookingId) =>
    `api/v3/tutor/close-reschedule-onboarding?booking_id=${bookingId}`;
// Firebase
export const TUTOR_INSTANT_BOOKINGS = (tutorId) =>
    `tutors/${tutorId}/invitations`;
export const TUTOR_SESSION_REMINDER = (tutorId) =>
    `tutors/${tutorId}/signals/session-reminder`;
export const TUTOR_CLOSE_SESSION_REMINDER =
    '/api/v3/tutor/close-session-reminder';

export const TUTOR_IGNORE_BOOKING = (bookingId) =>
    `/api/v3/bookings/${bookingId}/ignore-invitation`;
export const TUTOR_ABSENCE_REASON = (bookingId) =>
    `/api/v3/bookings/${bookingId}/add-absence-reason`;

export const CHANGE_PHONE_NUMBER_CHECK_XCPH = `${BASE}api/v3/auth/change-phone-number-check-xcph`;
export const SEND_CHANGE_PHONE_NUMBER_VERIFICATION_CODE = `${BASE}api/v3/auth/change-phone-number-sms-verification`;
export const CHANGE_PHONE_NUMBER = `${BASE}api/v3/auth/change-phone-number`;
export const PAY_STUDENT_DUES = (studentId) => `${BASE}api/v3/students/${studentId}/pay-dues`;
export const CHECK_STUDENT_DUES = `${BASE}api/v3/students/check-dues`;
export const GET_STUDENT_PAYMENT_INFO = (studentId) => `${BASE}api/v3/students/${studentId}/payment-info`;
export const STUDENT_SALES_REMARKS = (studentId) => `api/v3/students/${studentId}/sales-remarks`;
export const STUDENT_SALES_BRIEFS = (studentId) => `api/v3/students/${studentId}/sales-briefs`;

    export const WORKSHOP_DETAILS = (id) =>
`api/v3/workshops/${id}`;
export const WORKSHOP_DISCUSSIONS = (workshopId) =>
    `api/v3/workshops/${workshopId}/discussions`;
export const WORKSHOP_DISCUSSIONS_DETAILS = (workshopId, discussionId) =>
    `api/v3/workshops/${workshopId}/discussions/${discussionId}`;
export const WORKSHOP_DISCUSSIONS_NEW_COMMENT = (workshopId, discussionId) =>
    `api/v3/workshops/${workshopId}/discussions/${discussionId}/comments`;
export const WORKSHOP_CHECK_SESSION_STATUS =
    `api/v3/workshops/check-session-status`;

export const WORKSHOP_DISCUSSIONS_LIKE = (workshopId, discussionId) =>
    `api/v3/workshops/${workshopId}/discussions/${discussionId}/like`;

export const GET_SESSION_ANALYSIS = (sessionClassId) =>
    `${BASE}api/v3/session-analysis/${sessionClassId}`;
export const SEND_STUDENT_REPORT = `${BASE}api/v3/student/report-action`;


export const HOMEWORK_DETAILS = () => `${BASE}api/v3/homework`;

export const COMPLETE_HOMEWORK = (id) => `${BASE}api/v3/homework/${id}/complete`;

export const CREATE_BOOKING_INTENTION = `${BASE}api/v3/booking-intentions`;
export const BOOKING_INTENTION_VERIFY = `${BASE}api/v3/booking-intentions-verify`;
export const UPDATE_MUTE_STATUS = (bookingId) =>
    `api/v3/bookings/${bookingId}/toggle-students-mute`;

export const TAKAFUL_CAPTCHA = `${BASE}api/v3/takaful/captcha`
export const TAKAFUL_CHECK_STUDENT_STATUS = `${BASE}api/v3/takaful/check-student-status`
export const TAKAFUL_VERIFY_OTP = `${BASE}api/v3/takaful/verify-otp`
export const CLOSE_TAKAFUL_PUBNUB = `${BASE}api/v3/takaful/close-pubnub`
export const CHANGE_USER_PROFILE = `${BASE}api/v3/change-user-priority`
export const GET_TUTOR_ACHIEVEMENTS = `${BASE}api/v3/tutor/achievements`
export const CLOSE_JOIN_SESSION_PAGE = `${BASE}api/v3/student/close-join-session-page`


export const GET_RIYADH_TIME = `${BASE}api/v3/riyadh-time`;

export const TUTOR_SCHEDULE_SCHEDULE_SLOTS = (tutorId) => `${BASE}api/v3/tutor-schedule-slots/${tutorId}/schedule-slots`;
export const TRANSLOADIT_NOTIFY_URL = `${BASE}api/v3/webhooks/transloadit/notify`
export const CREATE_UNIVERSITY_BOOKING_URL = `${BASE}api/v3/university-booking`
export const SEARCH_UNIVERSITY_SUBJECT_URL = `${BASE}api/v3/university-booking/search`
export const UNIVERSITY_SEARCH_STATUS_URL = (searchId) => `${BASE}api/v3/university-booking/search/${searchId}/status`
export const UNIVERSITY_SEARCH_RESULT_URL = (searchId) => `${BASE}api/v3/university-booking/search/${searchId}/result`
export const MATCH_UNIVERSITY_SUBJECT_URL = `${BASE}api/v3/university-booking/match`
export const URGENT_TIME_OPTIONS = `${BASE}api/v3/urgent-time-options-sales`;

// Sales auth
export const SALES_LOGIN = 'api/v3/sales/auth/login';
export const SALES_ME = 'api/v3/sales/auth/me';
export const SALES_LOGOUT = 'api/v3/sales/auth/logout';
export const CLOSE_FIRST_BOOKING_MESSAGE = (booking_id) =>
    `${BASE}api/v3/bookings/close-first-booking-message?booking_id=${booking_id}`;
